import styled from 'styled-components';
import { media } from '@sizeid/commons/utils/styles';

export default styled.img`
  z-index: 2;
  position: relative;
  right: -35px;
  width: 150px;
  margin: 0 auto -60px auto;

  ${media.moreThan('sm')`
    margin-bottom: -120px;
  `};

  ${media.moreThan('md')`
    position: absolute;
    bottom: -150px;
    right: 40px;
    width: 280px;
    margin: 0;
  `};
`;
